export const SET_EXTERNAL_REPORTS = 'SET_EXTERNAL_REPORTS'
export const SET_ALL_EXTERNAL_REPORTS = 'SET_ALL_EXTERNAL_REPORTS'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_EXTERNAL_REPORTS_LOADED = 'SET_EXTERNAL_REPORTS_LOADED'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'
export const SET_EXTERNAL_REPORT_NAME = 'SET_EXTERNAL_REPORT_NAME'
export const SET_EXTERNAL_REPORT_ID = 'SET_EXTERNAL_REPORT_ID'
export const TOGGLE_EDIT_OVERLAY = 'TOGGLE_EDIT_OVERLAY'
export const SET_CURRENT_EXTERNAL_REPORT = 'SET_CURRENT_EXTERNAL_REPORT'
export const SET_CURRENT_EXTERNAL_REPORT_NAME =
	'SET_CURRENT_EXTERNAL_REPORT_NAME'
export const SET_CURRENT_EXTERNAL_REPORT_ID = 'SET_CURRENT_EXTERNAL_REPORT_ID'
export const TOGGLE_STATUS = 'TOGGLE_STATUS'
export const TOGGLE_CURRENT_STATUS = 'TOGGLE_CURRENT_STATUS'
export const SET_ITEMS = 'SET_ITEMS'
export const SET_PAGE_OF_ITEMS = 'SET_PAGE_OF_ITEMS'
export const SET_SERACH_VALUE_ON_CLICK = 'SET_SERACH_VALUE_ON_CLICK'
export const SELECT_EXTERNAL_REPORT = 'SELECT_EXTERNAL_REPORT'
export const SET_USER_EXTERNAL_REPORTS = 'SET_USER_EXTERNAL_REPORTS'